import client from "../Client/HttpClient";
import { IPaymentModel } from "@/interfaces/modules";

const ApiPath = "EnrollmentPayments";

export default {
    GetPayments: (data: IPaymentModel): Promise<IPaymentModel[]> => client.get(`${ApiPath}/byEnrollment/${data.EnrollmentId}`),
    GetPaymentById: (data: IPaymentModel): Promise<IPaymentModel> => client.get(`${ApiPath}/${data.Id}`),
    PostPayment: (data: IPaymentModel): Promise<IPaymentModel> => client.post(`${ApiPath}`, data)
};
